import { render } from "./CreateEnquiry.vue?vue&type=template&id=1c2046ad&scoped=true"
import script from "./CreateEnquiry.vue?vue&type=script&lang=js"
export * from "./CreateEnquiry.vue?vue&type=script&lang=js"

import "./CreateEnquiry.vue?vue&type=style&index=0&id=1c2046ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2046ad"]])

export default __exports__